// app/redux/reducers/demandesReducer.js

import {
    // common
    SET_DEMANDE_LOADING,
    CLEAR_DEMANDE_MESSAGE,

    // lists
    GET_MY_DEMANDES_REQUEST,
    GET_MY_DEMANDES_SUCCESS,
    GET_MY_DEMANDES_FAIL,

    GET_CREATED_BY_ME_DEMANDES_REQUEST,
    GET_CREATED_BY_ME_DEMANDES_SUCCESS,
    GET_CREATED_BY_ME_DEMANDES_FAIL,

    // create (3 modes)
    CREATE_DEMANDE_COLLAB_REQUEST,
    CREATE_DEMANDE_COLLAB_SUCCESS,
    CREATE_DEMANDE_COLLAB_FAIL,

    CREATE_DEMANDE_MANAGER_REQUEST,
    CREATE_DEMANDE_MANAGER_SUCCESS,
    CREATE_DEMANDE_MANAGER_FAIL,

    CREATE_DEMANDE_RF_REQUEST,
    CREATE_DEMANDE_RF_SUCCESS,
    CREATE_DEMANDE_RF_FAIL,

    // bulk
    CREATE_DEMANDE_MANAGER_BULK_REQUEST,
    CREATE_DEMANDE_MANAGER_BULK_SUCCESS,
    CREATE_DEMANDE_MANAGER_BULK_FAIL,

    CREATE_DEMANDE_RF_BULK_REQUEST,
    CREATE_DEMANDE_RF_BULK_SUCCESS,
    CREATE_DEMANDE_RF_BULK_FAIL,

    // inbox
    GET_DEMANDE_MANAGER_INBOX_REQUEST,
    GET_DEMANDE_MANAGER_INBOX_SUCCESS,
    GET_DEMANDE_MANAGER_INBOX_FAIL,

    GET_DEMANDE_RF_INBOX_REQUEST,
    GET_DEMANDE_RF_INBOX_SUCCESS,
    GET_DEMANDE_RF_INBOX_FAIL,

    // decisions
    DEMANDE_MANAGER_DECISION_REQUEST,
    DEMANDE_MANAGER_DECISION_SUCCESS,
    DEMANDE_MANAGER_DECISION_FAIL,

    DEMANDE_RF_DECISION_REQUEST,
    DEMANDE_RF_DECISION_SUCCESS,
    DEMANDE_RF_DECISION_FAIL, GET_COMPANY_DEMANDES_SUCCESS, GET_COMPANY_DEMANDES_FAIL,
} from "../actions/demandesActions";

const initialState = {
    loading: false,

    // messages / errors (affichage UI)
    message: null,
    error: null,

    // data
    myDemandes: [],
    createdByMeDemandes: [],

    managerInbox: [],
    rfInbox: [],
    companyDemandes: [], // NEW

    // last actions outputs (optionnel)
    lastCreated: null,
    lastBulkCreated: [],
    lastManagerDecision: null,
    lastRfDecision: null,
};

export default function demandesReducer(state = initialState, action) {
    switch (action.type) {
        // =====================
        // COMMON
        // =====================

        case GET_COMPANY_DEMANDES_SUCCESS:
            return { ...state, companyDemandes: action.payload || [], error: null };

        case GET_COMPANY_DEMANDES_FAIL:
            return { ...state, error: action.payload };
        case SET_DEMANDE_LOADING:
            return {
                ...state,
                loading: !!action.payload,
            };

        case CLEAR_DEMANDE_MESSAGE:
            return {
                ...state,
                message: null,
                error: null,
            };

        // =====================
        // LISTS - MY
        // =====================
        case GET_MY_DEMANDES_REQUEST:
            return {
                ...state,
                error: null,
            };

        case GET_MY_DEMANDES_SUCCESS:
            return {
                ...state,
                myDemandes: Array.isArray(action.payload) ? action.payload : [],
                error: null,
            };

        case GET_MY_DEMANDES_FAIL:
            return {
                ...state,
                error: action.payload || "Erreur chargement demandes",
            };

        // =====================
        // LISTS - CREATED BY ME
        // =====================
        case GET_CREATED_BY_ME_DEMANDES_REQUEST:
            return {
                ...state,
                error: null,
            };

        case GET_CREATED_BY_ME_DEMANDES_SUCCESS:
            return {
                ...state,
                createdByMeDemandes: Array.isArray(action.payload) ? action.payload : [],
                error: null,
            };

        case GET_CREATED_BY_ME_DEMANDES_FAIL:
            return {
                ...state,
                error: action.payload || "Erreur chargement demandes (créées par moi)",
            };

        // =====================
        // CREATE (3 MODES)
        // =====================
        case CREATE_DEMANDE_COLLAB_REQUEST:
        case CREATE_DEMANDE_MANAGER_REQUEST:
        case CREATE_DEMANDE_RF_REQUEST:
            return {
                ...state,
                error: null,
                message: null,
                lastCreated: null,
            };

        case CREATE_DEMANDE_COLLAB_SUCCESS:
        case CREATE_DEMANDE_MANAGER_SUCCESS:
        case CREATE_DEMANDE_RF_SUCCESS:
            return {
                ...state,
                lastCreated: action.payload || null,
                message: "Demande créée",
                error: null,
            };

        case CREATE_DEMANDE_COLLAB_FAIL:
        case CREATE_DEMANDE_MANAGER_FAIL:
        case CREATE_DEMANDE_RF_FAIL:
            return {
                ...state,
                error: action.payload || "Erreur création demande",
                message: null,
            };

        // =====================
        // BULK
        // =====================
        case CREATE_DEMANDE_MANAGER_BULK_REQUEST:
        case CREATE_DEMANDE_RF_BULK_REQUEST:
            return {
                ...state,
                error: null,
                message: null,
                lastBulkCreated: [],
            };

        case CREATE_DEMANDE_MANAGER_BULK_SUCCESS:
        case CREATE_DEMANDE_RF_BULK_SUCCESS:
            return {
                ...state,
                lastBulkCreated: Array.isArray(action.payload) ? action.payload : [],
                message: "Demandes bulk créées",
                error: null,
            };

        case CREATE_DEMANDE_MANAGER_BULK_FAIL:
        case CREATE_DEMANDE_RF_BULK_FAIL:
            return {
                ...state,
                error: action.payload || "Erreur création demandes bulk",
                message: null,
            };

        // =====================
        // INBOX - MANAGER
        // =====================
        case GET_DEMANDE_MANAGER_INBOX_REQUEST:
            return {
                ...state,
                error: null,
            };

        case GET_DEMANDE_MANAGER_INBOX_SUCCESS:
            return {
                ...state,
                managerInbox: Array.isArray(action.payload) ? action.payload : [],
                error: null,
            };

        case GET_DEMANDE_MANAGER_INBOX_FAIL:
            return {
                ...state,
                error: action.payload || "Erreur chargement inbox manager",
            };

        // =====================
        // INBOX - RF
        // =====================
        case GET_DEMANDE_RF_INBOX_REQUEST:
            return {
                ...state,
                error: null,
            };

        case GET_DEMANDE_RF_INBOX_SUCCESS:
            return {
                ...state,
                rfInbox: Array.isArray(action.payload) ? action.payload : [],
                error: null,
            };

        case GET_DEMANDE_RF_INBOX_FAIL:
            return {
                ...state,
                error: action.payload || "Erreur chargement inbox RF",
            };

        // =====================
        // DECISIONS
        // =====================
        case DEMANDE_MANAGER_DECISION_REQUEST:
        case DEMANDE_RF_DECISION_REQUEST:
            return {
                ...state,
                error: null,
                message: null,
            };

        case DEMANDE_MANAGER_DECISION_SUCCESS:
            return {
                ...state,
                lastManagerDecision: action.payload || null,
                message: "Décision manager envoyée",
                error: null,
            };

        case DEMANDE_RF_DECISION_SUCCESS:
            return {
                ...state,
                lastRfDecision: action.payload || null,
                message: "Décision responsable formation envoyée",
                error: null,
            };

        case DEMANDE_MANAGER_DECISION_FAIL:
            return {
                ...state,
                error: action.payload || "Erreur décision manager",
            };

        case DEMANDE_RF_DECISION_FAIL:
            return {
                ...state,
                error: action.payload || "Erreur décision responsable formation",
            };

        default:
            return state;
    }
}
